export interface ITagTypeOption {
  id: number;
  name: string;
  rowVersion: string;
}

export interface ITag {
  tagTypeName: string;
  id?: number;
  projectMasterScheduleId?: number;
  tagTypeId: number;
  name: string;
  rowVersion?: string;
}

export const createTagFormKeys = {
  TAG_TYPE: 'type',
  TAG_NAME: 'name',
};
